import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-interaktion',
  templateUrl: './interaktion.component.html',
  styleUrls: ['./interaktion.component.css']
})
export class InteraktionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
